import { s } from '@/theme/tokens';
import { Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type DetailTitlePrefixProps = {
  label: string;
  nowrap?: boolean;
};

export const DetailTitlePrefix = ({
  label,
  nowrap = false,
}: DetailTitlePrefixProps): ReactElement => (
  <Text
    role="sectionTitle"
    component="span"
    color="textSecondary"
    sx={{
      fontWeight: (theme) => theme.typography.fontWeightRegular,
      ...(nowrap ? { whiteSpace: 'nowrap' } : {}),
    }}
  >
    {label}
    <Text
      component="span"
      role="sectionTitle"
      color="textSecondary"
      sx={{
        display: 'inline-block',
        paddingLeft: s('md'),
        paddingRight: s('md'),
        fontWeight: (theme) => theme.typography.fontWeightRegular,
      }}
    >
      /
    </Text>
  </Text>
);
